export const ServiceType = {
  Featured: 1,
  PublishOnline: 2,
  BuyCredit: 3,
};

export const ServiceTypeLabels = {
  [ServiceType.Featured]: "In Evidenza",
  [ServiceType.PublishOnline]: "Pubblica Online",
  [ServiceType.BuyCredit]: "Acquisto Crediti",
};

export const ValidationStatus = {
  Waiting: 1,
  Validated: 2,
  Refused: 3
};

export const ValidationStatusLabels = {
  [ValidationStatus.Waiting]: "In attesa di validazione",
  [ValidationStatus.Validated]: "Validato",
  [ValidationStatus.Refused]: "Rifiutato",
};